import { useEffect, useRef, useState } from 'react';

export function trackRefreshInterval(pending, failed, active, deadline, now = Date.now()) {
  return pending === true && !failed && active && now < deadline ? 2000 : false;
}

export function createTrackRefreshWindow() {
  let currentIdentity = '';
  let deadline = null;
  return (identity, pending, failed, active, now = Date.now()) => {
    if (identity !== currentIdentity || !active || pending !== true) deadline = null;
    currentIdentity = identity;
    if (active && pending === true && !failed && deadline === null) deadline = now + 75_000;
    return trackRefreshInterval(pending, failed, active, deadline ?? 0, now);
  };
}
export function mergeRefreshedTracks(current, incoming) {
  if (!current || current.id !== incoming.id || current.sourceId !== incoming.sourceId)
    return incoming;
  const existing = new Map(
    current.tracks.filter((track) => track.id != null).map((track) => [track.id, track]),
  );
  return {
    ...current,
    tracksRefreshing: incoming.tracksRefreshing,
    tracks: incoming.tracks.map((track) => existing.get(track.id) ?? track),
  };
}
export function useAlbumTrackRefresh(identity) {
  const [active, setActive] = useState(document.visibilityState !== 'hidden');
  const window = useRef(createTrackRefreshWindow());
  useEffect(() => {
    const update = () => setActive(document.visibilityState !== 'hidden');
    document.addEventListener('visibilitychange', update);
    return () => document.removeEventListener('visibilitychange', update);
  }, []);
  return (query) =>
    window.current(
      identity,
      query.state.data?.data?.tracksRefreshing,
      query.state.status === 'error',
      active,
    );
}
